import { Col, Container, Row } from "react-bootstrap";
import laptopImg from "../../Assets/about.png";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import Github from "./Github";
import Techstack from "./Techstack";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Tentang <strong className="purple">Saya</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img
              src={laptopImg}
              alt="Ilustrasi tentang Dirham"
              className="img-fluid"
            />
          </Col>
        </Row>
        <h1 className="project-heading">
          <strong className="purple">Skillset</strong> Profesional
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> yang Saya Gunakan
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
